import PropTypes from 'prop-types';
import UIRadioInput from 'UIComponents/input/UIRadioInput';
import { EERIE } from 'HubStyleTokens/colors';
import Account from '../models/Account';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const AccountRow = ({
  account,
  selectedAccount,
  setSelectedAccount
}) => {
  return /*#__PURE__*/_jsxs("tr", {
    children: [/*#__PURE__*/_jsx("td", {
      className: "p-left-4",
      children: /*#__PURE__*/_jsx(UIRadioInput, {
        name: "row",
        onChange: () => setSelectedAccount(account),
        checked: selectedAccount ? account.get('id') === selectedAccount.get('id') : false,
        children: account.get('accountName') || account.get('domain')
      })
    }), /*#__PURE__*/_jsxs("td", {
      children: [account.get('domain'), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx("div", {
        className: "m-top-2",
        style: {
          color: EERIE
        },
        children: account.get('id')
      })]
    })]
  });
};
AccountRow.propTypes = {
  account: PropTypes.instanceOf(Account).isRequired,
  setSelectedAccount: PropTypes.func.isRequired,
  selectedAccount: PropTypes.instanceOf(Account)
};
export default AccountRow;